import { ReactNode } from "react";

interface Props {
  children: ReactNode;
}
export const BlogContentContainer = ({ children }: Props) => {
  return (
    <div className="bg-stone-500 w-full rounded-lg p-5 items-center">
      {children}
    </div>
  );
};
